<template>
  <!-- Closing CTA: two doors. A trainer starts alone; a studio with several trainers talks first,
       because trainers are added by ASport (backlog [F9]) — spec §3.9. -->
  <v-container fluid class="py-14 as-home-section as-home-section--grey">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <h2 class="as-home-heading">{{ $t('pages.home-view.closing.title') }}</h2>
        <p class="as-home-subheading">{{ $t('pages.home-view.closing.subtitle') }}</p>

        <v-row>
          <v-col cols="12" md="6" class="d-flex">
            <div class="as-home-door as-home-door--primary">
              <v-icon large color="var(--color-pallet-1)" class="mb-3">mdi-account</v-icon>
              <h3 class="as-home-door__title">{{ $t('pages.home-view.closing.trainer.title') }}</h3>
              <p class="as-home-door__text">{{ $t('pages.home-view.closing.trainer.text', { days: freeTrialDays }) }}</p>
              <v-btn color="var(--color-pallet-1)" dark x-large rounded block elevation="2" class="mt-auto" @click="$emit('start')">
                {{ $t('pages.home-view.cta.start-free') }}
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="d-flex">
            <div class="as-home-door">
              <v-icon large color="var(--color-pallet-1)" class="mb-3">mdi-account-group</v-icon>
              <h3 class="as-home-door__title">{{ $t('pages.home-view.closing.studio.title') }}</h3>
              <p class="as-home-door__text">{{ $t('pages.home-view.closing.studio.text') }}</p>
              <v-btn outlined color="var(--color-pallet-1)" x-large rounded block class="mt-auto" :href="studioContactUrl" @click="$emit('talk')">
                <v-icon left>mdi-email-outline</v-icon>
                {{ $t('pages.home-view.cta.talk') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { FREE_TRIAL_DAYS } from '@/domains/website/websiteLinks'

export default {
  name: 'HomeClosingSection',
  props: {
    /** mailto: link for studios ("Parunāsim — 15 min"). */
    studioContactUrl: { type: String, required: true }
  },
  data: () => ({
    freeTrialDays: FREE_TRIAL_DAYS
  })
}
</script>

<style>
.as-home-door {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--color-white);
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 28px;
}

/* Both doors' buttons the same height, whatever their style. */
.as-home-door .v-btn.v-size--x-large {
  height: auto;
  min-height: 52px;
}

.as-home-door--primary {
  border-color: var(--color-pallet-1);
}

.as-home-door__title {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--color-pallet-5);
  margin-bottom: 8px;
}

.as-home-door__text {
  color: var(--color-pallet-2);
  line-height: 1.6;
  margin-bottom: 24px;
}

/* A long label wraps instead of being cut (Vuetify buttons do not wrap by default). */
.as-home-door .v-btn__content,
.as-home-cta-row .v-btn__content {
  white-space: normal;
}
</style>
